import { useQuery } from "@tanstack/react-query";
import { chatService } from "@/services/chat-service";

export const userChatTokenKeys = {
  all: ["user-chat-token"] as const,
  hotel: (hotelId: string | null) =>
    [...userChatTokenKeys.all, hotelId ?? ""] as const,
};

export const useUserChatToken = (hotelId: string | null, enabled = true) => {
  const {
    data: userChatData,
    isLoading,
    error,
  } = useQuery({
    queryKey: userChatTokenKeys.hotel(hotelId),
    queryFn: async () => chatService.getHotelUserChatToken(),
    enabled: enabled && Boolean(hotelId),
  });

  return {
    userChatData,
    isLoading,
    error,
  };
};
